module.exports = __webpack_public_path__ + "img/gemini.7ee987b6.svg";